module.exports = __webpack_public_path__ + "img/Unit_Guide_Wine_bottle.9742c4ee.svg";